/* eslint-disable react-hooks/exhaustive-deps */
import { CheckboxActive, CheckboxDefault } from '@/assets/svg';
import { ClearComponent } from '@/new-components/ClearComponent';
import CustomLoadingButton from '@/new-components/CustomLoadingButton';
import CustomModalTitle from '@/new-components/CustomModal/CustomModalTitle';
import {
  Checkbox,
  DialogActions,
  FormControlLabel,
  Typography,
  InputAdornment,
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { isEmpty } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';

const UNIT_NUMBER_VALID_REGEX = /^[0-9]{1,2}-[0-9]{1,4}$/;

const TYPE_MODAL = {
  Create: 'create',
  Edit: 'edit',
};
const CustomDialogContent = withStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(3),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
}))(DialogContent);

const CustomDialog = withStyles({
  paper: {
    borderRadius: 16,
    width: 480,
  },
})(Dialog);

const CustomInputLabel = withStyles((theme) => ({
  root: {
    color: '#666666',
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
}))(InputLabel);

const CustomTextField = withStyles({
  root: {
    fontSize: 20,
    width: '100%',

    '& .MuiOutlinedInput-root': {
      height: 48,
      borderRadius: 8,
    },
    '& .MuiOutlinedInput-input': {
      marginRight: (props) => (props.hasClear ? 0 : 30),
      padding: '8px 5px',
      fontSize: 16,
    },

    '& .Mui-disabled': {
      '&.MuiOutlinedInput-root': {
        backgroundColor: '#f6f6f6',
      },
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
    '& .MuiInputBase-multiline': {
      height: 'auto',
      paddingLeft: 0,

      '& .MuiOutlinedInput-input': {
        marginRight: 8,
      },
    },
    '& .MuiInputBase-adornedStart': {
      '& .MuiTypography-root': {
        fontSize: 16,
        color: '#333333',
      },
      '& .MuiInputAdornment-positionStart': {
        marginRight: 0,
      },
      '& input': {
        marginLeft: 0,
      },
    },
  },
})(TextField);
const CustomDialogActions = withStyles({
  root: {
    margin: 0,
    padding: 16,
    justifyContent: 'flex-end',
    borderTop: '1px solid #E0E0E0',
  },
})(DialogActions);

const ModalAddOrEditAddress = ({
  open,
  onClose,
  onSubmit,
  typeModal,
  selectedAddress,
  parentId,
}) => {
  const [formValue, setFormValue] = useState({
    userId: '',
    address: '',
    unitNumber: '',
    postalCode: '',
    isDefault: false,
    longitude: 0,
    latitude: 0,
    floor: '',
    ignoredUnitNumber: false,
  });
  const [errors, setErrors] = useState({});
  const [unitNumber, setUnitNumber] = useState('');

  const handleChangeForm = (key) => (e, newValue) => {
    if (key === 'isDefault') {
      setFormValue({
        ...formValue,
        [key]: e.target.checked,
      });
    } else {
      setFormValue({ ...formValue, [key]: e.target.value });
    }
  };

  const sanitizeUnitNumberDisplay = (raw) => {
    const digitsAndDash = raw.replace(/[^0-9-]/g, '');
    const dashIndex = digitsAndDash.indexOf('-');
    const hasDash = dashIndex >= 0;

    const leftRaw = hasDash ? digitsAndDash.slice(0, dashIndex) : digitsAndDash;
    const rightRaw = hasDash
      ? digitsAndDash.slice(dashIndex + 1).replace(/-/g, '')
      : '';

    const left = leftRaw.slice(0, 2);
    const right = rightRaw.slice(0, 4);

    if (!hasDash) return left;
    return `${left}-${right}`;
  };

  const handleChangeUnitNumber = (e) => {
    const value = sanitizeUnitNumberDisplay(e.target.value);
    setUnitNumber(value);

    if (value.trim() === '') {
      setFormValue({
        ...formValue,
        floor: '',
        unitNumber: '',
        ignoredUnitNumber: false,
      });
      return;
    }

    if (UNIT_NUMBER_VALID_REGEX.test(value)) {
      const dashIndex = value.indexOf('-');
      const floor = value.slice(0, dashIndex);
      const unit = value.slice(dashIndex + 1);
      setFormValue({
        ...formValue,
        floor,
        unitNumber: unit,
        ignoredUnitNumber: false,
      });
    } else {
      setFormValue({
        ...formValue,
        floor: '',
        unitNumber: '',
        ignoredUnitNumber: false,
      });
    }
  };

  const handleInputUnitNumber = (e) => {
    const inputType = e?.nativeEvent?.inputType || '';
    if (inputType.startsWith('delete')) return;

    const raw = e.target.value || '';
    const digitsOnly = raw.replace(/[^0-9]/g, '');
    if (!raw.includes('-') && digitsOnly.length === 2) {
      e.target.value = `${digitsOnly}-`;
    }
  };

  const isEmptyParams = useMemo(() => {
    const filterKeys = ['address', 'postalCode'];

    let valid = false;
    if (unitNumber.trim() !== '' && !UNIT_NUMBER_VALID_REGEX.test(unitNumber)) {
      valid = true;
    }

    if (formValue.postalCode?.length < 6) valid = true;

    const checkValid = filterKeys.some((key) => !formValue[key]);
    return checkValid || valid;
  }, [formValue, unitNumber]);

  useEffect(() => {
    if (!isEmpty(selectedAddress)) {
      const display =
        selectedAddress.floor && selectedAddress.unitNumber
          ? `${selectedAddress.floor}-${selectedAddress.unitNumber}`
          : '';
      setUnitNumber(display);
      setFormValue({ ...selectedAddress, userId: parentId });
    } else setFormValue({ ...formValue, userId: parentId });
  }, []);

  return (
    <CustomDialog
      maxWidth="md"
      fullWidth
      scroll="body"
      disableEnforceFocus
      open={open}
      onClose={onClose}
      disableBackdropClick
    >
      <CustomModalTitle onClose={onClose}>
        {typeModal === 'create' ? 'Add Address' : 'Edit Address'}
      </CustomModalTitle>

      <CustomDialogContent>
        <CustomInputLabel>Address</CustomInputLabel>
        <CustomTextField
          id="address"
          fullWidth
          variant="outlined"
          placeholder="Enter address"
          value={formValue.address || ''}
          onChange={handleChangeForm('address')}
          error={!!errors?.address}
          helperText={!!errors.address}
          InputProps={{
            endAdornment: (
              <ClearComponent
                id="address"
                value={formValue.address}
                onClear={() => setFormValue({ ...formValue, address: '' })}
              />
            ),
          }}
        />

        <CustomInputLabel style={{ marginTop: 24 }}>
          Unit Number
        </CustomInputLabel>
        <Typography variant="body2" style={{ color: '#666', marginBottom: 4 }}>
          Please key 00-00 if not applicable
        </Typography>
        <CustomTextField
          id="unitNumber"
          fullWidth
          variant="outlined"
          placeholder="12-34"
          value={unitNumber || ''}
          onChange={handleChangeUnitNumber}
          onInput={handleInputUnitNumber}
          error={!!errors.unitNumber}
          helperText={errors.unitNumber}
          InputProps={{
            startAdornment: <InputAdornment position="start">#</InputAdornment>,
            endAdornment: (
              <ClearComponent
                id="unitNumber"
                value={unitNumber}
                onClear={() => {
                  setUnitNumber('');
                  setFormValue({
                    ...formValue,
                    floor: '',
                    unitNumber: '',
                    ignoredUnitNumber: false,
                  });
                }}
              />
            ),
          }}
        />
        <CustomInputLabel style={{ marginTop: 24 }}>
          Postal code
        </CustomInputLabel>
        <CustomTextField
          id="postalCode"
          fullWidth
          variant="outlined"
          placeholder="Enter code"
          value={formValue.postalCode || ''}
          onChange={handleChangeForm('postalCode')}
          error={!!errors.postalCode}
          helperText={errors.postalCode}
          style={{ marginBottom: 24 }}
          onInput={(e) => {
            e.target.value = e.target.value.toString().slice(0, 6);
          }}
          InputProps={{
            endAdornment: (
              <ClearComponent
                id="postalCode"
                value={formValue.postalCode}
                onClear={() => setFormValue({ ...formValue, postalCode: '' })}
              />
            ),
          }}
        />
        <FormControlLabel
          control={
            <Checkbox
              style={{ marginLeft: 3 }}
              checked={formValue?.isDefault}
              icon={<CheckboxDefault />}
              checkedIcon={<CheckboxActive />}
              color="primary"
              onChange={handleChangeForm('isDefault')}
            />
          }
          label="Set as the main delivery address"
        />
      </CustomDialogContent>

      <CustomDialogActions>
        <CustomLoadingButton
          type="submit"
          variant="contained"
          color="primary"
          onClick={() => onSubmit(formValue)}
          disabled={isEmptyParams}
        >
          {typeModal === TYPE_MODAL.Create ? 'Create' : 'Save'}
        </CustomLoadingButton>
      </CustomDialogActions>
    </CustomDialog>
  );
};

export default ModalAddOrEditAddress;
